import { CustomerStateType } from 'hooks/customer/types';
import { AuthenticationStateType } from 'hooks/authentication/types';
import { MojoContextType } from '../types';

export const getUserInfoContext = (
  newContext: {
    authenticationState: Partial<AuthenticationStateType>;
    customerState: Partial<CustomerStateType>;
  },
  cachedMojoContext: MojoContextType,
) => {
  // beware of casing inconsistencies.
  const {
    authenticationState: { browserCookieId, carvanaDeviceId, user },
    customerState: { userInfo },
  } = newContext;

  // localStorage entry already combines name fragments. Incoming does not.
  const newName =
    userInfo?.firstName && userInfo?.lastName
      ? `${userInfo.firstName} ${userInfo.lastName}`
      : undefined;
  const mojoName = newName || cachedMojoContext?.info?.user_info?.name || undefined;

  const userId = user?.user_id || cachedMojoContext?.info?.user_info?.user_id || undefined;
  const carvanaUserId =
    user?.user_id || cachedMojoContext?.info?.user_info?.carvana_user_id || undefined;

  const userInfoMojo = {
    ...(mojoName && { name: mojoName }),
    ...(userId && { user_id: userId }),
    ...(carvanaUserId && { carvana_user_id: carvanaUserId }),
  };

  // iOS Webview/localhost = carvanaDeviceId (cdid) and does not always exist. Web = browserCookieId (bcid).
  if (carvanaDeviceId) {
    return {
      ...userInfoMojo,
      carvana_device_id: carvanaDeviceId,
    };
  }
  return {
    ...userInfoMojo,
    carvana_browser_cookie_id:
      browserCookieId || cachedMojoContext?.info?.user_info?.carvana_browser_cookie_id || undefined,
  };
};
